import { Component, OnInit, ViewChild } from '@angular/core';
import { GridComponent, TableMode } from 'src/app/components/grid/grid.component';
import { FieldDataType } from 'src/app/components/grid/FieldDataType';
import { QueryOperand } from 'src/app/components/grid/QueryOperand';
import { ITableData } from 'src/app/components/grid/ITableData';
import { IColumn } from 'src/app/components/grid/IColumn';
import { IQuestionBank, IQuestionBankQuestion } from 'src/app/interface/dto';
import { QuestionBankService } from '../question-bank.service';
import { ActivatedRoute, Router } from '@angular/router';
import { GridUtil } from 'src/app/components/grid/GridUtil';
import { firstValueFrom } from 'rxjs';
import { EventService } from 'src/app/services/event-services/error-event.service';

@Component({
  selector: "app-questions",
  templateUrl: "./questions.component.html",
  styleUrls: ["./questions.component.scss"],
})
export class QuestionsComponent implements OnInit {
  selectedQuestions: IQuestionBankQuestion[] = [];
  gridName = "questionsGrid";
  questionList: IQuestionBankQuestion[] = [];
  modelError = "";
  selectedQuestion: IQuestionBankQuestion = null;
  selectedQuestionBank: IQuestionBank = null;
  questionBankID: number;
  @ViewChild("gridComponent") gridComponent!: GridComponent;

  constructor(
    private questionBankService: QuestionBankService,
    private router: Router,
    private actRoute: ActivatedRoute, private eventService: EventService
  ) { }

  data: ITableData = {
    tableRows: [],
    tableParams: {
      filterParams: [
        {
          fieldName: "questionBankID",
          fieldValue: `${this.questionBankService.selectedQuestionBankIds[0]}`,
          queryOperand: QueryOperand["=="],
          static: true,
        },
      ],
      sortParam: {
        fieldName: "",
        orderDirection: 0,
      },
      pageInfo: {
        previousPageSize: 50,
        page: 1,
        pageSize: 50,
        recordCount: 0,
        pageCount: 0,
      },
      tableMode: TableMode.serverProcessing,
      selectAll: false,
    },
  };

  columns: IColumn[] = [
    {
      displayName: "Question Type",
      fieldName: "questionType",
      fieldDataType: FieldDataType.enum,
      searchable: true,
      orderable: true,
    },
    {
      displayName: "Language",
      fieldName: "language",
      fieldDataType: FieldDataType.enum,
      searchable: true,
      orderable: true,
    },
    {
      displayName: "Question Html",
      fieldName: "questionHtml",
      fieldDataType: FieldDataType.text,
      searchable: true,
      orderable: true,
    },
    {
      displayName: "Category",
      fieldName: "category",
      fieldDataType: FieldDataType.text,
      searchable: true,
      orderable: true,
    },
    {
      displayName: "Question Group ID",
      fieldName: "questionGroupID",
      fieldDataType: FieldDataType.text,
      searchable: true,
      orderable: true,
    },
    {
      displayName: "Marks",
      fieldName: "marks",
      fieldDataType: FieldDataType.number,
      searchable: true,
      orderable: true,
    },
    {
      displayName: "Disabled",
      fieldName: "disabled",
      fieldDataType: FieldDataType.boolean,
      searchable: true,
      orderable: true,
    },
  ];

  async ngOnInit() {
    this.setQuestions([]);
    GridUtil.setClearGridSelection();

    const queryParams = await firstValueFrom(this.actRoute.params);
    this.questionBankID = queryParams['questionBankID'];

    if (this.questionBankService.selectedQuestionBanks.length === 1) {
      this.selectedQuestionBank = this.questionBankService.selectedQuestionBanks[0];
    }
    
    if (!this.questionBankService.selectedQuestionBankIds[0]) {
      this.data.tableParams.filterParams = [
        {
          fieldName: 'questionBankID',
          fieldValue: this.questionBankID.toString(),
          queryOperand: QueryOperand['=='],
          static: true,
        },
      ];
    }

    this.refreshData(this.data.tableParams);
  }

  addQuestion() {
    this.router.navigate([`questions-bank/${this.questionBankID}/questions/create`]);
  }

  editQuestion(event: any) {
    const questionID = this.questionBankService.selectedQuestions[0].id;

    this.router.navigate([`questions-bank/${this.questionBankID}/questions/${questionID}/update`]);
  }

  async refreshData(tableParams) {
    const res = (await this.questionBankService.getQuestions(
      tableParams
    )) as any[];
    this.updateGridParams(res);
  }

  updateGridParams(res: any) {
    if (!res) {
      return;
    }
    this.data.tableRows = [];
    const tableParams = { ...this.data.tableParams, pageInfo: res[0].pageInfo }
    this.data.tableParams = tableParams;
    this.data.tableRows = res.slice(1, res.length);
    setTimeout(() => {
      this.eventService.gridDataLoadedEvent.next(true);
    });
  }

  rowSelectedEvent(questionRowId: any[]) {
    if (!this.data?.tableRows?.length) { //Just in case tableRows might still not be ready
      setTimeout(() => this.rowSelectedEvent(questionRowId), 50);
      return;
    }

    let storedIds = GridUtil.getSelectedDataID(this.gridName) ?? [];
    const selectedQuestions: IQuestionBankQuestion[] = [];
    questionRowId.forEach((x) =>
      selectedQuestions.push(this.data.tableRows[x] as IQuestionBankQuestion)
    );
    let selectedDataRowsId =
      storedIds.length > 0 ? storedIds : selectedQuestions.map((x) => x.id);
    GridUtil.setRowCliclk(this.gridName, questionRowId, selectedDataRowsId);
    this.setQuestions(selectedQuestions);
  }

  setQuestions(questions: IQuestionBankQuestion[]) {
    this.selectedQuestions = questions;
    this.questionBankService.setSelectedQuestion([...this.selectedQuestions]);
  }
}